<template>
  <q-layout>
    <q-ajax-bar ref="bar" position="top" color="red-4" size="3px" skip-hijack></q-ajax-bar>
    <q-page-container v-if="pageLoad">
      <q-page>
        <div class="row justify-between">
          <q-btn class="q-ma-xs q-pr-md justify-left" ripple dense flat color="black" @click="dialogExit = true">
            <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
          </q-btn>
          <q-btn :loading="load" ripple icon="save" flat color="black" @click="dialogSubmit = true" size="25px"/>
        </div>
        <q-card class="q-my-xs q-pa-md" >
            <div class="text-h5 text-center q-py-md">Nhật ký chăm sóc lô</div>
            <div class="row">
              <div class="col-12 col-md-4 row items-center">
              <span class="text-weight-bold q-pb-md">Giám sát:</span>
              <span class="q-px-md q-pb-md" v-show="_.isEmpty(supervisors)">{{modelForShow.supervisor}}</span>
              <q-select
                class="q-px-md"
                style="min-width:200px"
                v-model="modelForShow.supervisor"
                v-show="!_.isEmpty(supervisors)"
                :error="errors.has('supervisor')"
                data-vv-validate-on="submitEvent"
                :error-message="errors.first('supervisor')"
                v-validate="'required'"
                ref = "supervisor"
                name = "supervisor"
                :options="supervisors"
                emit-value
                option-value="_id"
                :option-label="(item) => item.displayName ? item.displayName : item._id"
                :display-value="modelForShow.supervisor"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-4 q-mx-xs">
                  <div class="row">
                    <q-input class="col-10 self-center" v-model="modelDate" label="Ngày" readonly></q-input>
                    <q-btn icon="event" size="22px" style="height: 25%" flat class="col-2 cursor-pointer" @click="datePopUp = false">
                      <q-popup-proxy>
                        <q-date v-model="value" minimal v-close-popup="datePopUp"/>
                      </q-popup-proxy>
                    </q-btn>
                  </div>
              </div>
              <div class="col-xs-12 col-sm q-mx-xs">
                <q-select
                @blur="{}"
                :error="errors.has('farm')"
                data-vv-validate-on="blur|submitEvent"
                :error-message="errors.first('farm')" 
                v-validate="'required'"
                ref = "farm"
                name = "farm"
                emit-value v-model="modelForShow.farm" :options="farms" option-value="id" option-label="name" :display-value="$getNameById(farmStore.list, modelForShow.farm, 'name')" label="Nông trường" >
                  <template v-slot:prepend>
                    <q-icon name="filter_vintage" />
                  </template>
                </q-select>
              </div>
              <div class="col q-mx-xs">
                <q-select
                @blur="{}"
                :error="errors.has('lot')"
                data-vv-validate-on="blur|submitEvent"
                :error-message="errors.first('lot')"
                v-validate="'required'"
                ref = "lot"
                name = "lot"
                 emit-value v-model="modelForShow.lot" :options="lots" option-value="id" option-label="name" :display-value="$getNameById(lots, modelForShow.lot, 'name')" label="Lô" @click="tableKey++">
                  <template v-slot:prepend>
                    <q-icon name="local_florist" />
                  </template>
                </q-select>
              </div>
            </div>
            <span class="text-weight-bold" >Công việc</span>
            <div class="row">
              <q-select
                @blur="{}"
                :error="errors.has('job')"
                data-vv-validate-on="blur|submitEvent"
                :error-message="errors.first('job')"
                v-validate="'required'"
                ref = "job"
                name = "job"
                :use-input="modelForShow.job === null || modelForShow.job === undefined"
                @filter="filterJob"
                clearable
                emit-value class="col-12 col-sm"  v-model="modelForShow.job" :options="jobOptions" option-value="id" option-label="name" :display-value="$getNameById(jobStore.list, modelForShow.job, 'name')" label="Nội dung công việc">
                <template v-slot:prepend>
                  <q-icon name="pan_tool" />
                </template>
              </q-select>
              <q-input readonly class="col-6 col-sm q-mx-xs" v-model="modelForShow.totalWeight" label="Tổng khối lượng" type="number" bottom-slots>
                <template v-slot:prepend>
                  <q-icon name="money" />
                </template>
              </q-input>
              <q-input readonly class="col" v-model="unit" label="Đơn vị tính" type="text" bottom-slots>
                <template v-slot:prepend>
                  <q-icon name="local_atm" />
                </template>
              </q-input>
            </div>
            <span class="text-weight-bold" >Nhân công</span>
            <div class="row">
              <div class="col-12 col-lg q-mr-md">
                <span class="text-grey">Loại</span>
                <q-option-group 
                  :error="errors.has('jobType')"
                  data-vv-validate-on="submitEvent"
                  :error-message="errors.first('jobType')"
                  v-validate="'required'"
                  ref = "jobType"
                  name = "jobType"
                  inline v-model="modelForShow.worker.type" :options="workerTypes"/>
              </div>
            <q-input bottom-slots
            @blur="{}"
            :error="errors.has('mekaNumber')"
            data-vv-validate-on="blur|submitEvent"
            :error-message="errors.first('mekaNumber')" 
            name="mekaNumber"
            ref="mekaNumber"
            v-validate="{min_value:0, required: true}"
            class="col-xs-12 col-sm-5 col-md q-mx-xs" v-model="modelForShow.worker.number"
            label="Số lượng" type="number"
            >
              <template v-slot:prepend>
                <q-icon name="filter_9_plus" />
              </template>
            </q-input>
            <q-select
              :error="errors.has('meka')"
              @blur="{}"
                data-vv-validate-on="blur|submitEvent"
                :error-message="errors.first('meka')"
                v-validate="'required'"
                ref = "meka"
                name = "meka"
                @filter="filterMeka"
                :use-input="modelForShow.worker.meka === null || modelForShow.worker.meka === undefined"
                clearable
                emit-value bottom-slots class="col-xs-12 col-sm-6 col-md q-mx-xs" v-model="modelForShow.worker.meka" :options="mekaOptions" option-value="id" option-label="displayName" :display-value="$getNameById(mekaStore.list, modelForShow.worker.meka, 'displayName')" label="Meka">
              <template v-slot:prepend>
                <q-icon name="person" />
              </template>
            </q-select>
            </div>
        </q-card>

      <!-- Exit -->
      <q-dialog v-model="dialogExit" persistent>
        <q-card>
          <q-card-section class="row items-center">
            <q-avatar color="black" text-color="white">?</q-avatar>
            <span class="q-ml-sm">Bạn có muốn thoát ?</span>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn ripple flat icon="clear" v-close-popup/>
            <q-btn ripple flat icon="done"  v-close-popup to="/reports"/>
          </q-card-actions>
        </q-card>
      </q-dialog>

      <!-- Submit Data -->
      <q-dialog v-model="dialogSubmit" persistent>
        <q-card>
          <q-card-section class="row items-center">
            <q-avatar icon="save" color="black" text-color="white"/>
            <span class="q-ml-sm">Bạn có muốn lưu ?</span>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn ripple flat icon="clear" v-close-popup/>
            <q-btn ripple flat icon="done"  v-close-popup @click="submitData()"/>
          </q-card-actions>
        </q-card>
      </q-dialog>

        <q-table
          :data="modelForShow.details"
          :columns="headers"
          row-key="name"
          no-data-label="Không có dữ liệu"
          :key="tableKey"
          :pagination= {rowsPerPage:0}
          :hide-bottom="!_.isEmpty(modelForShow.details)"
          >
          <template v-slot:top-right="props">
            <q-btn round dense icon="add" color="green" @click="addItem()" class="q-mr-md"/>
          </template>
          <template v-slot:body ="props">
            <q-tr :props="props" v-if="props.row.deleted !== true">
              <q-td >{{ props.row.__index + 1}}</q-td>
              <q-td v-if="props.colsMap.slot" class="label-xs-right text-center">{{ showSlots(props.row.slots)}}</q-td>
              <q-td v-if="props.colsMap.weight" class="label-xs-right text-center">{{ props.row.weight}}</q-td>
              <q-td v-if="props.colsMap.picLocation" class="label-xs-right text-center">
                <q-btn style="height: 25%" size="15px" :color="(props.row.picLocation || props.row.pic) ? 'green' : 'black'" round icon='camera_enhance' @click="askCam(props)" />
              </q-td>
              <q-td v-if="props.colsMap.note" class="label-xs-right text-center">{{ props.row.note}}</q-td>
              <q-td v-if="props.colsMap.actions" class="label-xs-right text-center">
                <q-btn ripple flat round color="black" icon="edit" @click="clickEditButton(props)" />
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <!-- Edit form -->
    <q-dialog  v-if="dialogEdit" v-model="dialogEdit" persistent :key="dialogKey" >
      <q-card style="width:100vw; max-width:800px">
        <q-card-section>
          <div class="text-h6">Nhập dữ liệu</div>
        </q-card-section>
        <!-- Form render -->
        <q-card-section>
          <q-input
            bottom-slots
            @blur="{}"
            :error="errors.has('weight')"
            data-vv-validate-on="blur|submitEvent"
            :error-message="errors.first('weight')" 
            name="weight"
            ref="weight"
            v-validate="{min_value:0, required: true}"
            class="q-py-xs" v-model="model.weight" label="Khối lượng" type="number">
              <template v-slot:prepend>
                <q-icon name="fitness_center" />
              </template>
          </q-input>
            <!-- eslint-disable-next-line -->
            <div class="q-pt-md">Ô :</div>
            <div class="row q-py-xs" :key="modelKey">
              <q-chip class="col-5 col-sm-3 col-md-2" v-for="(item) in model.slots" :key="item.id" :selected.sync="item.picked" emit-value :color="!item.picked ? 'grey' : 'primary' " text-color="white" @click="modelKey++" >
                <div class="text-center break-word" style="text-overflow: ellipsis; overflow: hidden;white-space: nowrap;"> {{item.name}} </div>
              </q-chip>
            </div>
          
          <q-input v-model="model.note" filled type="textarea" label="Ghi chú">
            <template v-slot:prepend>
              <q-icon name="create" />
            </template>
          </q-input>

        </q-card-section>
        <!-- Functions -->
        <q-card-actions align="right">
          <q-btn v-if="!isAdding" flat ripple round icon="delete" @click="dialogDel = true"/>
          <q-btn ripple flat icon="clear" @click="resetData()" v-close-popup/>
          <q-btn flat ripple icon="done" @click="submitModel()"/>
        </q-card-actions>
      </q-card>
      <!-- Delete Record -->
      <q-dialog v-model="dialogDel" persistent>
        <q-card>
          <q-card-section class="row items-center">
            <q-avatar icon="delete" color="black" text-color="white"/>
            <span class="q-ml-sm">Bạn có chắc chắn muốn xóa ?</span>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn ripple flat icon="clear" v-close-popup/>
            <q-btn ripple flat icon="done"  v-close-popup @click="deleteItem()"/>
          </q-card-actions>
        </q-card>
      </q-dialog>
    </q-dialog>
        <!-- Camera -->
      <q-dialog v-if="dialogCam" v-model="dialogCam" persistent>
        <q-card class="camera-wrap">
          <q-card-section class="text-right">
            <q-btn round flat icon="clear" v-close-popup  @click="stop()"/>
          </q-card-section>
          <q-card-section class="text-center camera-section relative">
          <div v-show="camIsOn" class="row absolute q-px-lg q-py-xs text-red">
            <div class="col-12"> {{ moment(new Date()).format(showDateFormat)}} {{location.latitude + ' ' + location.longitude}}</div>
          </div>
            <video ref='video' playsinline autoplay :width="$q.screen.width*0.7" v-show="camIsOn"></video>
            <img ref='videoImg' :src='model.pic' :width="$q.screen.width*0.7" v-show="!camIsOn"/>
            <canvas ref='canvas' style='display:none'></canvas>
          </q-card-section>
          <q-card-actions class="justify-center items-center" align="center">
            <q-btn color="black" round icon="switch_camera" @click='flip()'/>
            <q-btn size="25px" round color='black' :icon="camIsOn ? 'camera' : 'cached' " @click='capture()'/>
            <q-btn color="black" round icon="done" @click='camDone()'/>
          </q-card-actions>
        </q-card>
      </q-dialog>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import moment from 'moment'
import { firebase } from '@firebase/app'
import { date } from 'quasar'
import { mapGetters } from 'vuex'
// eslint-disable-next-line
import _ from 'lodash'
export default {
  props: {
    reportId: String,
    mode: String
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data() {
    return {
      defaultDateFormat: 'DD/MM/YYYY',
      showDateFormat: 'DD/MM/YYYY HH:MM Z',
      yearMonthFormat: 'YYYYMM',
      quasarFormat: 'YYYY/MM/DD',
      value: '',
      modelDate: null,
      datePopUp: false,
      model: {},
      dialogExit: false,
      dialogEdit: false,
      dialogCam: false,
      dialogDel: false,
      dialogSubmit: false,
      camIsOn: false,
      pageLoad: false,
      video: {},
      canvas: {},
      captures: [],
      front: false,
      img: {src : undefined},
      tableKey: 0,
      dialogKey: 1,
      modelKey: 2,
      load : false,
      reports: {},
      supervisors: [],
      jobOptions: [],
      mekaOptions: [],
      modelForShow: {
      },
      isAdding: false,
      location: {},
      selectedRowIndex: -1,
      workerTypes: [
        {
          label: 'Công nhật',
          value: 'congnhat',
          id: 'congnhat'
        },
        {
          label: 'Công khoán',
          value: 'khoan',
          id: 'khoan'
        }
      ],
      farms: [],
      mekas: [],
      headers: [{
          label: "No",
          align: "left",
          name: "no"
        },
        {
          label: "Ô",
          align: "center",
          name: "slot"
        },
        {
          label: "Khối lượng",
          align: "center",
          name: "weight"
        },
        {
          label: "Ảnh",
          align: "center",
          name: "picLocation"
        },
        {
          label: "Ghi chú",
          align: "center",
          name: "note"
        },
        {
          label: "Thao tác",
          align: "center",
          name: "actions"
        }]
    }
  },
  async mounted() {
    let vm = this
    try {
      vm.askLoc()
      vm.loading(true)
      vm.$nextTick(() => {
        vm.$refs.bar.start()
      })
      let f = vm.farmStore
      let j = vm.jobStore
      let m = vm.mekaStore
      let r
      let s

      //check roles
      const regexFarm = /(^F[0-9]M$)/
      let roles = vm.permission.roles
      let fm = Object.keys(roles).filter((item) => regexFarm.test(item))
      if(roles.hasOwnProperty('BOM') || !this._.isEmpty(fm)) {
        s = await this.$query(['Users'],[['roles.SUPVR','==',true]])
      }
      //if EDIT
      if (vm.reportId && vm.mode !== 'CREATE') {
        r = vm.getReports(vm.reportId)
      }
      Promise.all([f, j, m, r, s]).then(res => {
        try {
        res.forEach(item => {
          if (item && item.hasOwnProperty('error'))
            throw item.error
        })
        vm.farms = res[0].list
        vm.jobs = res[1].list ? res[1].list.filter(item => item.deleted===false).sort((a, b) => a.name.localeCompare(b.name)) : []
        // filter harvest
        // let rejectId = ['chichbap', 'baobuong', 'thubq', 'catbup']
        // vm.jobs = vm.jobs ? vm.jobs.filter(item => rejectId.indexOf(item.id) == -1) : []
        vm.mekas = res[2].list ? res[2].list.sort((a, b) => a.displayName.localeCompare(b.displayName)) : []
        vm.supervisors = res[4] ? res[4].data : []

        //if CREATE
      
        if (vm.mode === 'CREATE' || !vm.reportId) {
          vm.modelForShow = vm.initModelForShow()
          vm.value = date.formatDate(new Date(), this.quasarFormat)
        }
        else {
          vm.reports = res[3]
          vm.modelForShow = res[3] ? vm._.cloneDeep(res[3]) : {}
          console.log(vm.modelForShow)
        }
      
        vm.curUser = vm.curUser ? '' : vm.$store.getters.user.email

        vm.modelDate = !vm.modelForShow.date ? date.formatDate(new Date(), vm.defaultDateFormat) : date.formatDate(this.modelForShow && this.modelForShow.date instanceof firebase.firestore.Timestamp ? this.modelForShow.date.toDate() : '', this.defaultDateFormat)
        vm.pageLoad = true
        vm.$refs.bar ? vm.$refs.bar.stop() : null
        }
        catch (er) {
          vm.$refs.bar ? vm.$refs.bar.stop() : null
          vm.$q.notify({
            message: er.message,
            color: 'red',
            icon: 'error'
          })
        }
      })
    } catch (error) {
      vm.$refs.bar ? vm.$refs.bar.stop() : null
      vm.$q.notify({
        message: error.message,
        color: 'red',
        icon: 'error'
      })
    }
    vm.loading(false)
  },
  watch: {
    farms() {
      this.modelForShow.farm = this.modelForShow.farm ? this.modelForShow.farm : this.farms && this.farms[0] && this.farms[0].id ? this.farms[0].id : null
    },
    'modelForShow.job': {
      // eslint-disable-next-line no-unused-vars
      handler: function(newVal, oldVal) {
        let vm = this
        vm.unit = this.$getNameById(this.jobStore.list, newVal, 'unit')
      },
      deep: true
    },
    'dialogEdit': {
      // eslint-disable-next-line no-unused-vars
      handler: function(newVal, oldVal) {
        let vm = this
        vm.modelForShow.totalWeight = vm.sumWeight()
      },
      deep: true
    },
    'value': {
      handler: function(newVl, oldVl) {
        let newVlMoment = moment(newVl, this.quasarFormat)
        let oldVlMoment = moment(oldVl, this.quasarFormat)
        this.modelForShow.date = firebase.firestore.Timestamp.fromDate(moment.utc(newVl, this.quasarFormat).toDate())
        this.modelDate = date.formatDate(newVl, this.defaultDateFormat)
        this.datePopUp = !oldVl ? (newVlMoment.date() !== oldVlMoment.date() ? true 
          : newVlMoment.month() !== oldVlMoment.month() || newVlMoment.year() !== oldVlMoment.year()) 
            : true
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters([
      'user',
      'permission',
      'isAnonymous',
      'farmStore',
      'mekaStore',
      'jobStore'
    ]),
    lots: function () {
      let vm = this
      let lots = this.$getNameById(vm.farms, vm.modelForShow.farm, 'listLot')
      lots = lots ? lots.sort((a,b) => a.name && b.name && (parseFloat(a.name) - parseFloat(b.name))) : []
      if (vm.modelForShow.lot) {
        let findLot = this._.find(lots, {id:vm.modelForShow.lot})
        vm.modelForShow.lot = findLot && vm.modelForShow.lot === findLot.id ? vm.modelForShow.lot : lots[0] ? lots[0].id : ''
      }
      else vm.modelForShow.lot = lots[0] ? lots[0].id : ''
      return lots ? lots : []
    },
    slots: function() {
      let vm = this
      if (vm.modelForShow.lot) {
        let slots = this.$getNameById(vm.lots, vm.modelForShow.lot, 'listSlot')
        for (let i in slots) {
          slots[i].picked = false
        }
        return slots ? slots : []
      }
      return []
    },
    yearMonth: function() {
      let vm = this
      return !vm.modelForShow.date ? date.formatDate(new Date(), vm.yearMonthFormat) 
      : date.formatDate(vm.modelForShow && vm.modelForShow.date instanceof firebase.firestore.Timestamp ? vm.modelForShow.date.toDate() 
      : '', vm.yearMonthFormat)
    }
  },
  methods: {
    loading(isLoad) {
      this.load = isLoad
    },
    getReports(id) {
      return this.$query(['Reports', id],['deleted','==',false])
    },
    getJobs() {
      return this.jobs.filter(item => item.deleted===false)
    },
    validate() {
      let vm = this
      vm.$refs.supervisor.$emit('submitEvent', vm.modelForShow.supervisor)
      vm.$refs.farm.$emit('submitEvent', vm.modelForShow.farm)
      vm.$refs.lot.$emit('submitEvent', vm.modelForShow.lot)
      vm.$refs.job.$emit('submitEvent', vm.modelForShow.job)
      vm.$refs.jobType.$emit('submitEvent', vm.modelForShow.worker.type)
      vm.$refs.mekaNumber.$emit('submitEvent', vm.modelForShow.worker.number)
      vm.$refs.meka.$emit('submitEvent', vm.modelForShow.worker.meka)
      return vm.errors.has('supervisor')||vm.errors.has('farm')||vm.errors.has('lot')||vm.errors.has('job')||vm.errors.has('jobType')||vm.errors.has('mekaNumber')||vm.errors.has('meka')
    },
    addItem() {
      this.validate()
      this.$nextTick(() => {
        if (!this.errors.has('farm')|| !this.errors.has('lot'))
        {
          this.resetData()
          this.isAdding = true
          this.dialogEdit = true
          this.model.slots = this._.cloneDeep(this._.omit(this.slots,['area','total','name']))
          this.$nextTick(() => {
            this.dialogKey++
          })
        }
        else {
          this.$q.notify({
            message: 'Vui lòng thử lại',
            color: 'red',
            icon: 'error'
          })
        }
      })
    },
    clickEditButton (props) {
      var vm = this
      vm.dialogEdit = true
      vm.selectedRowIndex = props.row.__index
      vm.model = vm._.cloneDeep(vm.modelForShow.details[vm.selectedRowIndex])

      //init slots
      let tmpSlots = vm._.cloneDeep(vm.$getNameById(vm.lots, vm.modelForShow.lot, 'listSlot'))

      for (let i in tmpSlots) {
        tmpSlots[i].picked = tmpSlots[i].picked ? tmpSlots[i].picked : false
      }

      for (let i in vm.model.slots) {

        let iden = (typeof vm.model.slots[i] === 'number') ? vm.model.slots[i] : vm.model.slots[i].id

        let findInModel = vm._.findIndex(tmpSlots, {id:iden})
        if (findInModel > -1 ) {
          tmpSlots[findInModel].picked = (typeof vm.model.slots[i] === 'number') ? true : false
        }
      }

      vm.model.slots = tmpSlots
      vm.$nextTick(() => {
        vm.dialogKey ++
      })
    },
    filterSlot(slots) {
      let filteredSlot = []
      let all = []
      for (let index in slots) {
        if (typeof slots[index] === 'number') {
          all.push(slots[index])
          filteredSlot.push(slots[index])
        }
        if (typeof slots[index] === 'object')
        {
          all.push(slots[index].id)
          if (slots[index].picked !== false)
          filteredSlot.push(slots[index].id)
        }
      }
      return !this._.isEmpty(filteredSlot) ? filteredSlot : all
    },
    // eslint-disable-next-line
    filterJob(val, update, abort) {
      let vm = this
      update(() => {
        if (val === '') {
          this.jobOptions = vm.jobs.filter(item => item.deleted===false)
        }
        else {
          const needle = val.toLowerCase()
          this.jobOptions = vm.jobs.filter(v => (
            v.deleted===false &&
              ((v.name && v.name.toLowerCase().indexOf(needle) > -1) ||
              (v.jobCode && v.jobCode.toLowerCase().indexOf(needle.replace(/\s/g, '')) > -1))
            ))
        }
      })
    },
    // eslint-disable-next-line
    filterMeka(val, update, abort) {
      let vm = this
      update(() => {
        if (val === '') {
          this.mekaOptions = vm.mekas
        }
        else {
          const needle = val.toLowerCase()
          this.mekaOptions = vm.mekas.filter(v => (
              (v.displayName && v.displayName.toLowerCase().indexOf(needle) > -1) ||
              (v.email && v.mekaId.toLowerCase().indexOf(needle.replace(/\s/g, '')) > -1) ||
              (v.mekaId && v.mekaId.toLowerCase().indexOf(needle.replace(/\s/g, '')) > -1) ||
              (v.email && v.email.toLowerCase().indexOf(needle.replace(/\s/g, '')) > -1)
            ))
        }
      })
    },
    deleteItem() {
      let vm = this
      vm.modelForShow.details[vm.selectedRowIndex].deleted = true
      vm.dialogDel = false
      vm.dialogEdit = false
      vm.resetData()
      vm.tableKey ++
    },
    submitModel() {
      let vm = this
      vm.$refs.weight.$emit('submitEvent', vm.model.weight)
      vm.modelForShow.details = vm.modelForShow.details ? vm.modelForShow.details : []
      vm.$nextTick(()=> {
        if (!vm.errors.has('weight')) {
          vm.model.slots = vm._.cloneDeep(vm.filterSlot(vm.model.slots))
          if (vm.isAdding) {
            vm.modelForShow.details.push(vm._.cloneDeep(vm.model))
          }
          else vm.modelForShow.details[vm.selectedRowIndex] = vm._.omit(vm._.cloneDeep(vm.model), '__index')
          vm.dialogEdit = false
          vm.resetData()
          // vm.tableKey++
        }
        else {
          vm.$q.notify({
            message: 'Vui lòng thử lại',
            color: 'red',
            icon: 'error'
          })
        }
      })
    },
    resetData() {
      this.isAdding = false
      this.model = {
        deleted: false
      }
    },
    askLoc() {
      let vm = this
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          function(position) {
            vm.location = position.coords
          },
          function(err) {
            console.warn('ERROR(' + err.code + '): ' + err.message)
            alert('ERROR(' + err.code + '): ' + err.message)
        })
      }
    },
    async askCam(props) {
      let vm = this
      vm.$refs.bar.start()
      vm.selectedRowIndex = props.row.__index
      vm.model = vm._.cloneDeep(vm.modelForShow.details[vm.selectedRowIndex])
      vm.model.location = !vm.location.latitude ? '' : (vm.location.latitude + ' ' + vm.location.longitude)
      try {
        if (!vm.model.pic && vm.model.picLocation) {
          vm.model.pic = await vm.$storage.ref(vm.model.picLocation).getDownloadURL()
        }
      }
      catch (error) {
        vm.camIsOn = true
      }
      vm.dialogCam = true
      vm.$refs.bar ? vm.$refs.bar.stop() : null
      vm.$nextTick(() => {
        vm.video = vm.$refs.video
        vm.canvas = vm.$refs.canvas
        vm.getStream()
        })
    },
    async getStream() {
      let vm = this
      
      if (!navigator.getUserMedia && !navigator.webkitGetUserMedia && !navigator.mozGetUserMedia && !navigator.msGetUserMedia) {
        alert('Can not access to camera.')
        return
      }

      if (await vm.model.pic) {
        vm.camIsOn = false
        return
      }

      let constraints = { video: { facingMode: !vm.front ? 'user' : {exact: 'environment'} } }
      navigator.mediaDevices.getUserMedia(constraints)
        .then(stream => {
          if ('srcObject' in vm.video)
          vm.video.srcObject = stream
          this.localstream = stream
          vm.camIsOn = true
        }, err => {
          console.warn('ERROR(' + err.code + '): ' + err.message)
          vm.$q.notify({
              message: 'Error: ' + err.message,
              color: 'red',
              icon: 'error'
            })
        })
    },
    getUserMedia(options, success, failure) {
      let api = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia
      if (api) return api.bind(navigator)(options, success, failure)
    },
    capture() {
      let vm = this
      if (vm.camIsOn) {
        vm.askLoc()
        vm.model.location =  !vm.location.latitude ? '' : (vm.location.latitude + ' ' + vm.location.longitude)
        vm.canvas.width = vm.video.videoWidth
        vm.canvas.height = vm.video.videoHeight
        vm.model.date = moment.utc().toDate()
        vm.canvas.getContext("2d").drawImage(vm.video, 0, 0)
        let date = moment(new Date()).format(vm.showDateFormat)
        vm.canvas.getContext("2d").font = "15px Roboto"
        vm.canvas.getContext("2d").fillStyle = "red"
        vm.canvas.getContext("2d").fillText(date + ' ' + vm.model.location,10,20)
        vm.model.pic = vm.canvas.toDataURL('image/png')
        vm.stop()
      }
      else {
        vm.model.pic = null
        vm.model.picLocation = null
        vm.getStream()
      }
    },
    stop() {
      this.camIsOn = false
      return this.video.srcObject && this.video.srcObject.getTracks().map(t => t.stop());
    },
    flip() {
      this.front = !this.front
      this.stop()
      this.img.src = ''
      this.getStream()
      this.capture()
    },
    camDone() {
      this.modelForShow.details[this.selectedRowIndex] = this.model
      this.resetData()
      this.stop()
      this.dialogCam = false
      this.tableKey ++
    },
    sumWeight() {
      let sum = 0
      if (this._.isEmpty(this.modelForShow.details)) return 0
      for (let item in this.modelForShow.details) {
        if (this.modelForShow.details[item].weight && this.modelForShow.details[item].deleted !== true)
          sum += parseFloat(this.modelForShow.details[item].weight)
      }
      return sum
    },
    submitData() {
      let vm = this
      vm.validate()
      vm.$nextTick(()=> {
        if (vm.errors.items.length > 0 ) {
          vm.$q.notify({
            message: 'Lưu thất bại',
            color: 'red',
            icon: 'error'
          })
          return
        }
        else {
          vm.loading(true)
          vm.modelForShow.yearMonth = vm.yearMonth
          let submitModel = { id: vm.reportId, data: vm._.cloneDeep(vm.convertBinary(vm.modelForShow))}
          vm.$command.execute('updateReport', submitModel).then( () => {
            vm.loading(false)
            vm.$q.notify({
              message: 'Đã lưu thành công',
              color: 'black',
              icon: 'check'
            })
            if (vm.mode === 'CREATE' || !vm.reportId) {
              vm.$router.push('/reports')
            }
          }).catch((error) => {
            vm.loading(false)
            console.log(error)
            vm.$q.notify({
              message: 'Lưu thất bại: ' + error.message,
              color: 'red',
              icon: 'error'
            })
          })
        }
      })
    },
    convertBinary(model) {
      let vm = this
      let m = vm._.cloneDeep(model)
      m.details.forEach(item => {
        if (item.pic) item.pic = vm.getBinary(item.pic)
      })
      return m
    },
    getBinary (file) {
      try {
        return window.atob(file.replace(/^data:(.*;base64,)?/, ''))
      }
      catch (err) {
        return file
      }
    },
    initModelForShow() {
      return {
        date: moment(new Date()).format(this.defaultDateFormat),
        deleted: false,
        details: [],
        supervisor: (this.modelForShow.supervisor) ? this.modelForShow.supervisor : this._.isEmpty(this.supervisors) ? this.$store.getters.user.email : '',
        totalWeight: 0,
        worker: {
          type: this.workerTypes[0].id
        },
        lot: ''
      }
    },
    showSlots(propSlots) {
      return !this._.isEmpty(propSlots) ? propSlots.toString() : ''
    },
    moment(timestamp) {
      return moment(timestamp)
    },
    firebase() {
      return firebase
    }
  }
}
</script>

<style scoped>
video {
   /* -webkit-transform: scaleX(-1);
  transform: scaleX(-1); */
}
.camera-wrap {
  width: 80vw;
  height: 90vh;
  max-width: unset;
  max-height: 90vh;
}
.camera-wrap .q-card__section {
  margin: 0;
  padding: 0 !important;
}
</style>
